import { DropdownItem } from "@rui/Dropdown/types";

export const DEPARTMENTS: DropdownItem[] = [
  { label: "Administration", value: "administration" },
  { label: "Business Development", value: "business_development" },
  { label: "Communications", value: "communications" },
  { label: "Consulting", value: "consulting" },
  { label: "Customer Service", value: "customer_service" },
  { label: "Design", value: "design" },
  { label: "Education", value: "education" },
  { label: "Engineering", value: "engineering" },
  { label: "Finance", value: "finance" },
  { label: "Healthcare", value: "healthcare" },
  { label: "Human Resources (HR)", value: "human_resources" },
  { label: "Information Technology (IT)", value: "information_technology" },
  { label: "Legal", value: "legal" },
  { label: "Logistics", value: "logistics" },
  { label: "Manufacturing", value: "manufacturing" },
  { label: "Marketing", value: "marketing" },
  { label: "Media and Entertainment", value: "media_and_entertainment" },
  { label: "Nonprofit", value: "nonprofit" },
  { label: "Operations", value: "operations" },
  { label: "Procurement", value: "procurement" },
  { label: "Product Management", value: "product_management" },
  { label: "Project Management", value: "project_management" },
  { label: "Public Relations (PR)", value: "public_relations" },
  { label: "Quality Assurance (QA)", value: "quality_assurance" },
  { label: "Real Estate", value: "real_estate" },
  {
    label: "Research and Development (R&D)",
    value: "research_and_development",
  },
  { label: "Retail", value: "retail" },
  { label: "Sales", value: "sales" },
  { label: "Supply Chain", value: "supply_chain" },
  { label: "Other", value: "other" },
];

export const ROLE_LEVELS: DropdownItem[] = [
  { label: "Executive", value: "executive" },
  { label: "Manager", value: "manager" },
  { label: "Individual Contributor", value: "individual_contributor" },
  { label: "Other", value: "other" },
];
